import * as yup from 'yup'
import {
  validateRequiredDate,
  validateRequiredPositiveNumberWithCommas,
  validateRequiredString,
  validateStartBeforeEndDate
} from '../../../../utils'
import { ACCRUAL_BASE_TYPE_PERCENTAGE } from '../../constants'
import { CalculateMembershipFeeInput } from '../types'

export const validationSchema = yup.object().shape({
  startDate: validateRequiredDate(
    'pages.membershipFeesPage.calculateMembershipFeePage.validation.required'
  ),
  endDate: validateStartBeforeEndDate<CalculateMembershipFeeInput>(
    'startDate',
    'pages.membershipFeesPage.calculateMembershipFeePage.validation.endBeforeStart',
    'pages.membershipFeesPage.calculateMembershipFeePage.validation.required'
  ),
  amount: validateRequiredPositiveNumberWithCommas().test(
    'amount-not-too-big',
    'pages.membershipFeesPage.calculateMembershipFeePage.validation.amountTooLarge',
    (value) => {
      return value != null && value < 999999.99
    }
  ),
  grossSalary: yup.number().when('type', {
    is: ACCRUAL_BASE_TYPE_PERCENTAGE,
    then: validateRequiredPositiveNumberWithCommas()
  }),
  type: validateRequiredString(
    'pages.membershipFeesPage.calculateMembershipFeePage.validation.required'
  )
})
